import TemporaryItems from './TemporaryItems'
import MenuItem from "../../../core/components/menu/MenuItem";
import i18n from './../../../shared/i18n';
import ArchivedTemporaryItems from "./ArchivedTemporaryItems"
import ActiveTemporaryItems from "./ActiveTemporaryItems"

let routes = [
  {
    path: 'temporary',
    name: 'temporary',
    component: TemporaryItems,
    redirect: 'temporary/active',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'active',
        name: 'temporary.active',
        component: ActiveTemporaryItems
      },
      {
        path: 'archived',
        name: 'temporary.archived',
        component: ArchivedTemporaryItems
      },
    ]
  }
];

export default {
  menuItem: new MenuItem('/temporary', i18n.t('Temporary'), 41, 'box-open', [], 'view_temporaryinventoryitem'),
  routes: routes
}
